import React, { Component } from "react";
import axios from "axios";
import config from "react-global-configuration";
import { Card, Label, Input, Button } from "reactstrap";
import CommonNavbar from "./commonNavbar";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import jwt_decode from "jwt-decode";

class AdminBankSchemesEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      bankDetails: {
        issuerBankName: "",
        emiTenure: "",
        partyType: "",
        partyName: "",
        roi: "",
        effectiveRoi: "",
      },
      updatedRoi: "",
      updatedEffectiveRoi: "",
      scheduleDateTime: new Date(),
      // selectedOption: "", // Stores "NCE", "LCE", or ""
    };
  }

  componentDidMount() {
    this.fetchBankDetails();
  }

  fetchBankDetails = () => {
    const bankId = this.props.match.params.id;
    axios
      .post(
        `${config.get("API_URL")}/brandemi/get-bank-details`,
        { id: bankId },
        { headers: { Authorization: ` ${localStorage.usertoken}` } }
      )
      .then((response) => {
        this.setState({
          bankDetails: response.data,
          updatedRoi: response.data.roi,
          updatedEffectiveRoi: response.data.effectiveRoi,
          originalScheduleDateTime: new Date(),
          scheduleDateTime: new Date(),
          loading: false,
        });
      })
      .catch((error) => {
        console.error("Error fetching bank details:", error);
        this.setState({ loading: false });
      });
  };

  handleInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleDateChange = (date) => {
    this.setState({ scheduleDateTime: date });
  };

  // handleRadioChange = (option) => {
  //   this.setState({ selectedOption: option === this.state.selectedOption ? "" : option });
  // };

  handleSubmit = () => {
    const { updatedRoi, updatedEffectiveRoi, scheduleDateTime } = this.state;
    // const bankId = this.props.match.params.id;
    const bankId = parseInt(this.props.match.params.id); // Ensure it's a number
    const token = localStorage.usertoken;
    const decoded = jwt_decode(token);

    if (!updatedRoi || !updatedEffectiveRoi || !scheduleDateTime) {
      alert("Please enter ROI, Effective ROI, and a valid Schedule Date-Time.");
      return;
    }

    const confirmUpdate = window.confirm(
      `Are you sure you want to update the ROI and Effective ROI for Bank ID: ${bankId}?`
    );
    if (!confirmUpdate) return;
    console.log("Payload being sent to /update-bank-details:", {
    id: bankId,
    roi: parseFloat(updatedRoi),
    effectiveRoi: parseFloat(updatedEffectiveRoi),
    scheduleDateTime: scheduleDateTime.toISOString(),
    user: decoded._id
  });
    axios
      .post(
        `${config.get("API_URL")}/brandemi/update-bank-details`,
        {
          id: bankId,
          roi: parseFloat(updatedRoi),
          effectiveRoi: parseFloat(updatedEffectiveRoi),
          scheduleDateTime: scheduleDateTime.toISOString(),
          user: decoded._id
        },
        { headers: {
          Authorization: ` ${localStorage.usertoken}`,
            "Content-Type": "application/json"
        } }
      )
      .then(() => {
        alert("Bank schemes updated successfully!");
        this.fetchBankDetails();
      })
      .catch((error) => {
        console.error("Error updating bank details:", error);
        alert("Failed to update bank details.");
      });
  };

  goBack = () => {
    this.props.history.goBack();
  };

  hasChanges = () => {
    const { bankDetails, updatedRoi, updatedEffectiveRoi, scheduleDateTime } = this.state;
    const roiChanged = parseFloat(updatedRoi) !== parseFloat(bankDetails.roi);
    const effectiveRoiChanged = parseFloat(updatedEffectiveRoi) !== parseFloat(bankDetails.effectiveRoi);
    const scheduleChanged = new Date(scheduleDateTime).getTime() !== new Date(this.state.originalScheduleDateTime).getTime();
  
    return roiChanged || effectiveRoiChanged || scheduleChanged;
  };

  render() {
    const { loading, bankDetails, updatedRoi, updatedEffectiveRoi, scheduleDateTime, selectedOption } = this.state;
    if (loading) return <div>Loading...</div>;

    return (
      <div className="content longcontent">
        <CommonNavbar />
        <div className="container-fluid">
          <div className="card-query-builder top-pad-5">
            <div className="col-md-12">
              <div className="card">
                <div className="header">
                  <h4 className="title pull-left">Update Bank Schemes</h4>
                  <Button color="primary" className="btn-capitalize pull-right" onClick={this.goBack}>
                    Go Back
                  </Button>
                </div>

                <div className="content">
                  <div className="container-fluid">
                    {/* Bank Name and EMI Tenure */}
                    <div className="row top-margin-10">
                      <div className="col-md-6">
                        <Label>Bank Name</Label>
                        <Input type="text" value={bankDetails.issuerBankName} disabled/>
                      </div>
                      <div className="col-md-6">
                        <Label>EMI Tenure</Label>
                        <Input type="text" value={bankDetails.emiTenure} disabled/>
                      </div>
                    </div>

                    {/* ROI and Effective ROI */}
                    <div className="row top-margin-10">
                      <div className="col-md-6">
                        <Label>ROI</Label>
                        <Input type="number" name="updatedRoi" value={updatedRoi} onChange={this.handleInputChange}/>
                      </div>
                      <div className="col-md-6">
                        <Label>Effective ROI</Label>
                        <Input type="number" name="updatedEffectiveRoi" value={updatedEffectiveRoi}
                               onChange={this.handleInputChange}/>
                      </div>
                    </div>

                    {/* Schedule Date-Time */}
                    <div className="row top-margin-10">
                      <div className="col-md-6">
                        <Label>Schedule Update Date-Time</Label>
                        <DatePicker selected={scheduleDateTime} onChange={this.handleDateChange} showTimeSelect
                                    dateFormat="Pp" className="form-control"/>
                      </div>

                      {/* NCE/LCE Selection
                      <div className="row top-margin-10">
                        <div className="col-md-6">
                          <Label>Update Type</Label>
                          <div>
                            <Input className="radio-margin-8" type="radio" name="updateType" checked={selectedOption === "NCE"}
                                   onChange={() => this.handleRadioChange("NCE")}/> NCE &nbsp;&nbsp;&nbsp;
                            <Input className="radio-margin-8" type="radio" name="updateType" checked={selectedOption === "LCE"}
                                   onChange={() => this.handleRadioChange("LCE")}/> LCE &nbsp;&nbsp;&nbsp;
                          </div>
                        </div>
                      </div> */}
                    </div>

                    {/* Submit Button */}
                    <div className="row top-margin-10">
                      <div className="col-md-12">
                        <button onClick={this.handleSubmit} className="btn btn-primary btn-capitalize pull-left" disabled={!this.hasChanges}>Submit
                        </button>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AdminBankSchemesEdit;
